<template>
  <fieldset class="mt-4">
    <div class="space-y-4">
      <div :id="id" v-for="option in options" :key="option.value" class="flex items-center">
        <input :id="option.value" v-model="value" type="radio" :value="option.value" class="radio" />
        <label :for="option.value" class="radio-label">
          {{ option.label }}
        </label>
      </div>
    </div>
  </fieldset>
</template>

<script setup>
import { ref, watch } from 'vue';
const props = defineProps({id: String, options: Array, modelValue: String});
const emits = defineEmits(['update:modelValue']);
const value = ref(props.modelValue);
const change = watch(value, (v) => emits('update:modelValue', v));
</script>

<style scoped>
.radio-input
{
  @apply h-4 w-4;
  @apply border-gray-300;
  @apply text-teal-600;
  @apply focus:ring-teal-500;
};

.radio-label
{
  @apply ml-3 block;
  @apply font-medium;
  @apply text-sm;
  @apply text-gray-700;
};
</style>
